 const filterSurveyStatus = [
  { name: "Approved", filter: 0 },
  { name: "Pending", filter: 1 },
  { name: "Closed", filter: 2 },
  { name: "RejectedByMD", filter: 3 },
  { name: "Declined", filter: 7 },
  { name: "RejectedByEDO", filter: 9 },
  { name: "ApprovedByMD", filter: 10 },
  { name: "Cancelled", filter: 11 },
  { name: "Paid", filter: 13 },
  { name: "Retired", filter: 14 },
  { name: "Authorized", filter: 16 },
  { name: "Draft", filter: 17 },
  { name: "ApprovedByHR", filter: 20 },
  { name: "RejectedByEDFI", filter: 27 },
  { name: "MakePayment", filter: 29 },
  { name: "ApprovedByEDO", filter: 30 },
  { name: "DeclinePayment", filter: 39 },
  { name: "ApprovedByHOU", filter: 40 },
  { name: "ApprovedByHOD", filter: 50 },
  { name: "ApprovedByEDFI", filter: 60 },
  { name: "RejectedByHR", filter: 81 },
  { name: "Terminated", filter: 100 },
  { name: "AwaitingControlReview", filter: 101 },
  { name: "AwaitingControlApproval", filter: 102 },
  { name: "ApproveFinance", filter: 103 },
  { name: "RejectedByHOD", filter: 243 },
  { name: "RejectedByHOU", filter: 729 }
]

export { filterSurveyStatus };